import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-results-loader',
    templateUrl: './results-loader.component.html',
    styleUrls: ['./results-loader.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ResultsLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
